<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="row">
  <div class="col-12">
    <app-card cardTitle="Mensagens Diárias - Organização Semanal" [options]="false">
      <div class="alert alert-info">
        <i class="feather icon-info"></i> 
        Configure mensagens motivacionais para cada dia da semana. As mensagens serão enviadas automaticamente no horário programado.
      </div>

      <!-- Grid de Dias da Semana -->
      <div class="row dias-semana-grid">
        <!-- Cards dos dias -->
        <div class="col-lg-4 col-md-6 mb-4" *ngFor="let dia of diasSemana; let i = index">
          <div class="card dia-card" [ngClass]="'dia-' + i">
            <div class="card-header">
              <h5 class="mb-0">
                <i class="feather icon-calendar"></i> 
                {{dia.nome}}
              </h5>
              <span class="badge badge-light">{{getMensagensCount(dia.id)}} mensagem(ns)</span>
            </div>
            <div class="card-body">
              <!-- Lista de mensagens do dia -->
              <div class="mensagem-item" *ngFor="let msg of getMensagensDia(dia.id); let j = index">
                <div class="mensagem-header">
                  <span class="horario-badge">
                    <i class="feather icon-clock"></i> {{msg.horario}}
                  </span>
                  <div class="mensagem-actions">
                    <button class="btn btn-sm btn-icon btn-warning" 
                            (click)="editarMensagem(dia.id, j)"
                            title="Editar">
                      <i class="feather icon-edit"></i>
                    </button>
                    <button class="btn btn-sm btn-icon btn-danger" 
                            (click)="removerMensagem(dia.id, j)"
                            title="Remover">
                      <i class="feather icon-trash-2"></i>
                    </button>
                  </div>
                </div>
                <div class="mensagem-content">
                  <h6 class="mb-2 text-primary">{{msg.titulo}}</h6>
                  <p class="mb-0">{{msg.mensagem}}</p>
                </div>
                <div class="mensagem-status">
                  <span class="badge" [ngClass]="msg.ativo ? 'badge-success' : 'badge-secondary'">
                    {{msg.ativo ? 'Ativo' : 'Inativo'}}
                  </span>
                </div>
              </div>

              <!-- Mensagem vazia -->
              <div class="empty-state" *ngIf="getMensagensCount(dia.id) === 0">
                <i class="feather icon-message-circle"></i>
                <p>Nenhuma mensagem cadastrada</p>
              </div>

              <!-- Botão para adicionar mensagem -->
              <button class="btn btn-primary btn-block mt-3" (click)="abrirModalMensagem(dia.id)">
                <i class="feather icon-plus"></i> Adicionar Mensagem
              </button>
            </div>
          </div>
        </div>
      </div>
    </app-card>
  </div>
</div>

<!-- Modal para Adicionar/Editar Mensagem -->
<div class="modal fade show" *ngIf="modalAberto" tabindex="-1" role="dialog">
  <div class="modal-backdrop fade show" (click)="fecharModal()"></div>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="feather icon-message-square"></i> 
          {{mensagemEditando !== null ? 'Editar' : 'Nova'}} Mensagem - {{getDiaNome(diaSelecionado)}}
        </h5>
        <button type="button" class="close" (click)="fecharModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="sub-title">Título <span class="text-danger">*</span></label>
              <input type="text" 
                     class="form-control" 
                     [(ngModel)]="novaMensagem.titulo" 
                     name="titulo"
                     placeholder="Ex: Mensagem Motivacional da Manhã">
              <small class="form-text text-muted">Título da mensagem que será exibido</small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="sub-title">Horário de Envio <span class="text-danger">*</span></label>
              <input type="time" 
                     class="form-control" 
                     [(ngModel)]="novaMensagem.horario" 
                     name="horario"
                     placeholder="Ex: 08:00">
              <small class="form-text text-muted">Hora em que a mensagem será enviada</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="sub-title">Status</label>
              <div class="switch switch-success d-inline m-r-10">
                <input type="checkbox" 
                       id="switch-status" 
                       [(ngModel)]="novaMensagem.ativo" 
                       name="ativo">
                <label for="switch-status" class="cr"></label>
              </div>
              <label>{{novaMensagem.ativo ? 'Ativo' : 'Inativo'}}</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="sub-title">Mensagem <span class="text-danger">*</span></label>
              <textarea class="form-control" 
                        rows="5" 
                        [(ngModel)]="novaMensagem.mensagem" 
                        name="mensagem"
                        placeholder="Digite aqui a mensagem motivacional..."></textarea>
              <small class="form-text text-muted">
                Caracteres: {{novaMensagem.mensagem?.length || 0}}
              </small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="alert alert-light">
              <strong>Prévia da mensagem:</strong>
              <div class="mt-2 p-3 bg-white rounded border">
                <h6 class="text-primary mb-2">{{novaMensagem.titulo || 'Título da mensagem'}}</h6>
                <p class="mb-0">{{novaMensagem.mensagem || 'A mensagem aparecerá aqui...'}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="fecharModal()">
          <i class="feather icon-x"></i> Cancelar
        </button>
        <button type="button" class="btn btn-primary" (click)="salvarMensagem()">
          <i class="feather icon-save"></i> Salvar Mensagem
        </button>
      </div>
    </div>
  </div>
</div>

